<template>
  <div class="page-wrapper">
    <div class="page-container">
      
      <!-- Top Filter & Action Bar -->
      <div class="action-bar-card no-print">
        <div class="filters-left">
          <!-- Kafedra tanlash selecti -->
          <div class="select-box select-kafedra">
            <label class="field-label">
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="label-icon"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
              Kafedrani tanlang:
            </label>
            <SearchableSelect
              v-model="selectedDepartmentId"
              :options="kafedraOptions"
              :disabled="isKafedraMudirRole"
              placeholder="Kafedrani qidirish va tanlash..."
              @update:modelValue="onDepartmentChange"
            />
          </div>

          <!-- O'quv yili -->
          <div class="select-box select-year">
            <label class="field-label">
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="label-icon"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
              O'quv yili:
            </label>
            <div class="year-select-wrapper">
              <select v-model="selectedYear" class="form-select" @change="fetchSummaryData">
                <option value="2026-2027">2026-2027</option>
                <option value="2025-2026">2025-2026</option>
                <option value="2024-2025">2024-2025</option>
              </select>
            </div>
          </div>
        </div>

        <div class="actions-right">
          <button class="btn-action btn-excel" @click="exportToExcel" :disabled="loading || !summaryData" title="Excel formatida yuklab olish">
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
            <span>Excelga yuklash</span>
          </button>
          <button class="btn-action btn-print" @click="printTable" :disabled="loading || !summaryData" title="Chop etish yoki PDF sifatida saqlash">
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 6 2 18 2 18 9"></polyline><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path><rect x="6" y="14" width="12" height="8"></rect></svg>
            <span>Chop etish</span>
          </button>
          <button class="btn-action btn-refresh" @click="fetchSummaryData" :disabled="loading" title="Ma'lumotlarni qayta yuklash">
            <svg :class="{ 'spinning': loading }" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 4 23 10 17 10"></polyline><polyline points="1 20 1 14 7 14"></polyline><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path></svg>
            <span>Yangilash</span>
          </button>
        </div>
      </div>

      <!-- Loading State -->
      <div v-if="loading" class="loading-state">
        <div class="spinner"></div>
        <p>Ma'lumotlar yuklanmoqda...</p>
      </div>

      <!-- Table Container -->
      <div v-else-if="summaryData" class="document-container" id="printable-taqsimot">
        
        <!-- Header Signers & Title Box -->
        <div class="doc-header-box">
          <div class="signer-col left-signer">
            <div class="signer-title">"Tasdiqlayman"</div>
            <div class="signer-role">O'quv ishlari bo'yicha prorektor</div>
            <div class="signer-line">___________ B.Primkulov</div>
            <div class="signer-date">«____» ____________ 2026 y.</div>
          </div>

          <div class="signer-col right-signer">
            <div class="signer-title">"Kelishildi"</div>
            <div class="signer-role">O'quv-uslubiy boshqarma boshlig'i</div>
            <div class="signer-line">___________ A.Ibragimov</div>
            <div class="signer-date">«____» ____________ 2026 y.</div>
          </div>
        </div>

        <div class="doc-main-title">
          Termiz davlat muhandislik va agrotexnologiyalar universiteti {{ summaryData.department.name }} kafedrasi professor-o'qituvchilariga {{ selectedYear }} o'quv yili uchun o'quv yuklama
        </div>
        <div class="doc-sub-title">
          TAQSIMOTI
        </div>

        <!-- The Table -->
        <div class="table-responsive">
          <table class="taqsimot-table">
            <thead>
              <!-- Top Row -->
              <tr>
                <th rowspan="2" class="th-num">№</th>
                <th rowspan="2" class="th-name">Professor-o'qituvchining familiyasi, ismi, sharifi</th>
                <th rowspan="2" class="th-pos">Lavozimi</th>
                <th rowspan="2" class="th-staff th-v"><div class="v-text">Shtat birligi</div></th>
                <th colspan="5" class="th-group-audit">Auditoriya mashg'ulotlari</th>
                <th colspan="21" class="th-group-tashqari">Auditoriyadan tashqari mashg'ulotlari</th>
                <th rowspan="2" class="th-jami-tashqari th-v"><div class="v-text">Jami auditoriyadan tashqari soat</div></th>
                <th rowspan="2" class="th-hammasi th-v"><div class="v-text">Hammasi</div></th>
              </tr>
              <!-- Sub Row with Vertical Headings -->
              <tr class="sub-header-row">
                <!-- Auditoriya (TaqsimotJadval bilan bir xil tartibda: Ma'ruza, Amaliy, Seminar, Laboratoriya) -->
                <th class="th-v"><div class="v-text">Ma'ruza</div></th>
                <th class="th-v"><div class="v-text">Amaliy mashg'ulot</div></th>
                <th class="th-v"><div class="v-text">Seminar</div></th>
                <th class="th-v"><div class="v-text">Laboratoriya</div></th>
                <th class="th-v th-audit-total"><div class="v-text">Jami auditoriya soati</div></th>

                <!-- Tashqari 21 columns -->
                <th class="th-v"><div class="v-text">Kurs ishi (Talaba soni*2)</div></th>
                <th class="th-v"><div class="v-text">Kurs ishi himoyasi (Talaba soni*0,4)</div></th>
                <th class="th-v"><div class="v-text">Kurs loyihasi (Talaba soni*3)</div></th>
                <th class="th-v"><div class="v-text">Kurs loyihasi himoyasi (Talaba soni*0,6)</div></th>
                <th class="th-v"><div class="v-text">Hisob chizma ishi (Talaba soni*0,3)</div></th>
                <th class="th-v"><div class="v-text">Oraliq nazorat (Talaba soni*0,2)</div></th>
                <th class="th-v"><div class="v-text">Yakuniy nazorat (Talaba soni*0,3)</div></th>
                <th class="th-v"><div class="v-text">Malakaviy amaliyot individual (talaba soni*2)</div></th>
                <th class="th-v"><div class="v-text">Malakaviy amaliyot universitet hududida (3*6*hafta soni*guruh soni)</div></th>
                <th class="th-v"><div class="v-text">Malakaviy amaliyot universitetdan tashqari hududda (boshqa ta'lim yo'nalishi talaba soni*25, sirtqi yo'nalishiga talaba soni*50)</div></th>
                <th class="th-v"><div class="v-text">BMI rahbarlik (Boshqa ta'lim yo'nalishlari talaba soni*25, texnik yo'nalishlarga talaba soni*30)</div></th>
                <th class="th-v"><div class="v-text">BMI/DAK (Talaba soni*0,4)</div></th>
                <th class="th-v"><div class="v-text">Magistrlik IPF va amaliyotga rahbarlik (Talaba soni*50)</div></th>
                <th class="th-v"><div class="v-text">MD - ITI ga rahbarlik qilish (Talaba soni*50)</div></th>
                <th class="th-v"><div class="v-text">MD/DAK (Talaba soni*0,8)</div></th>
                <th class="th-v"><div class="v-text">Doktorantga (stajyor tadqiqotchiga talaba soni*75) rahbarlik (Talaba soni*100)</div></th>
                <th class="th-v"><div class="v-text">YaDA yozma ish guruh soni*3</div></th>
                <th class="th-v"><div class="v-text">YaDA yozma ish tekshirish uchun talaba soni*0,2</div></th>
                <th class="th-v"><div class="v-text">YaDA test guruh soni*1</div></th>
                <th class="th-v"><div class="v-text">Ochiq leksiya (dars soni*5)</div></th>
                <th class="th-v"><div class="v-text">Respublika ta'lim muassasalarida markazlarida malaka oshirishlarni o'tash</div></th>
              </tr>
            </thead>
            <tbody>
              <!-- SECTION 1: Asosiy shtat bo'yicha -->
              <tr class="section-title-row">
                <td colspan="32">Asosiy shtat bo'yicha</td>
              </tr>
              <tr v-for="(t, idx) in summaryData.sections.asosiy.teachers" :key="'asosiy_' + idx">
                <td class="td-c">{{ idx + 1 }}</td>
                <td class="td-name">{{ t.name }}</td>
                <td class="td-c text-red-600 font-semibold">{{ t.position }}</td>
                <td class="td-c">{{ t.staff }}</td>
                <td class="td-c">{{ t.maruza || '' }}</td>
                <td class="td-c">{{ t.amaliy || '' }}</td>
                <td class="td-c">{{ t.seminar || '' }}</td>
                <td class="td-c">{{ t.laboratoriya || '' }}</td>
                <td class="td-c td-audit-total">{{ t.jamiAuditoriya || '' }}</td>
                <td class="td-c">{{ t.kursIshi || '' }}</td>
                <td class="td-c">{{ t.kursIshiHimoya || '' }}</td>
                <td class="td-c">{{ t.kursLoyihasi || '' }}</td>
                <td class="td-c">{{ t.kursLoyihasiHimoya || '' }}</td>
                <td class="td-c">{{ t.hisobChizma || '' }}</td>
                <td class="td-c">{{ t.oraliq || '' }}</td>
                <td class="td-c">{{ t.yakuniy || '' }}</td>
                <td class="td-c">{{ t.amaliyotInd || '' }}</td>
                <td class="td-c">{{ t.amaliyotUni || '' }}</td>
                <td class="td-c">{{ t.amaliyotTash || '' }}</td>
                <td class="td-c">{{ t.bmiRahbar || '' }}</td>
                <td class="td-c">{{ t.bmiDak || '' }}</td>
                <td class="td-c">{{ t.magistr || '' }}</td>
                <td class="td-c">{{ t.mdIti || '' }}</td>
                <td class="td-c">{{ t.mdDak || '' }}</td>
                <td class="td-c">{{ t.doktorant || '' }}</td>
                <td class="td-c">{{ t.yadaYozmaGuruh || '' }}</td>
                <td class="td-c">{{ t.yadaYozmaTalaba || '' }}</td>
                <td class="td-c">{{ t.yadaTest || '' }}</td>
                <td class="td-c">{{ t.ochiqLeksiya || '' }}</td>
                <td class="td-c">{{ t.malakaOshirish || '' }}</td>
                <td class="td-c td-tashqari-total">{{ t.jamiTashqari || '' }}</td>
                <td class="td-c td-grand-total">{{ t.hammasi || '' }}</td>
              </tr>
              <!-- Section 1 Subtotal -->
              <tr class="section-subtotal-row">
                <td colspan="3" class="text-center font-bold">Jami</td>
                <td class="td-c font-bold">{{ summaryData.sections.asosiy.totalStaff }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.asosiy.totals.maruza || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.asosiy.totals.amaliy || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.asosiy.totals.seminar || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.asosiy.totals.laboratoriya || '' }}</td>
                <td class="td-c font-bold td-audit-total">{{ summaryData.sections.asosiy.totals.jamiAuditoriya || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.asosiy.totals.kursIshi || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.asosiy.totals.kursIshiHimoya || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.asosiy.totals.kursLoyihasi || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.asosiy.totals.kursLoyihasiHimoya || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.asosiy.totals.hisobChizma || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.asosiy.totals.oraliq || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.asosiy.totals.yakuniy || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.asosiy.totals.amaliyotInd || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.asosiy.totals.amaliyotUni || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.asosiy.totals.amaliyotTash || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.asosiy.totals.bmiRahbar || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.asosiy.totals.bmiDak || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.asosiy.totals.magistr || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.asosiy.totals.mdIti || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.asosiy.totals.mdDak || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.asosiy.totals.doktorant || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.asosiy.totals.yadaYozmaGuruh || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.asosiy.totals.yadaYozmaTalaba || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.asosiy.totals.yadaTest || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.asosiy.totals.ochiqLeksiya || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.asosiy.totals.malakaOshirish || '' }}</td>
                <td class="td-c font-bold td-tashqari-total">{{ summaryData.sections.asosiy.totals.jamiTashqari || '' }}</td>
                <td class="td-c font-bold td-grand-total">{{ summaryData.sections.asosiy.totals.hammasi || '' }}</td>
              </tr>

              <!-- SECTION 2: Ichki o'rindoshlik asosida -->
              <tr class="section-title-row">
                <td colspan="32">Ichki o'rindoshlik asosida</td>
              </tr>
              <tr v-for="(t, idx) in summaryData.sections.ichki.teachers" :key="'ichki_' + idx">
                <td class="td-c">{{ idx + 1 }}</td>
                <td class="td-name">{{ t.name }}</td>
                <td class="td-c text-red-600 font-semibold">{{ t.position }}</td>
                <td class="td-c">{{ t.staff }}</td>
                <td class="td-c">{{ t.maruza || '' }}</td>
                <td class="td-c">{{ t.amaliy || '' }}</td>
                <td class="td-c">{{ t.seminar || '' }}</td>
                <td class="td-c">{{ t.laboratoriya || '' }}</td>
                <td class="td-c td-audit-total">{{ t.jamiAuditoriya || '' }}</td>
                <td class="td-c">{{ t.kursIshi || '' }}</td>
                <td class="td-c">{{ t.kursIshiHimoya || '' }}</td>
                <td class="td-c">{{ t.kursLoyihasi || '' }}</td>
                <td class="td-c">{{ t.kursLoyihasiHimoya || '' }}</td>
                <td class="td-c">{{ t.hisobChizma || '' }}</td>
                <td class="td-c">{{ t.oraliq || '' }}</td>
                <td class="td-c">{{ t.yakuniy || '' }}</td>
                <td class="td-c">{{ t.amaliyotInd || '' }}</td>
                <td class="td-c">{{ t.amaliyotUni || '' }}</td>
                <td class="td-c">{{ t.amaliyotTash || '' }}</td>
                <td class="td-c">{{ t.bmiRahbar || '' }}</td>
                <td class="td-c">{{ t.bmiDak || '' }}</td>
                <td class="td-c">{{ t.magistr || '' }}</td>
                <td class="td-c">{{ t.mdIti || '' }}</td>
                <td class="td-c">{{ t.mdDak || '' }}</td>
                <td class="td-c">{{ t.doktorant || '' }}</td>
                <td class="td-c">{{ t.yadaYozmaGuruh || '' }}</td>
                <td class="td-c">{{ t.yadaYozmaTalaba || '' }}</td>
                <td class="td-c">{{ t.yadaTest || '' }}</td>
                <td class="td-c">{{ t.ochiqLeksiya || '' }}</td>
                <td class="td-c">{{ t.malakaOshirish || '' }}</td>
                <td class="td-c td-tashqari-total">{{ t.jamiTashqari || '' }}</td>
                <td class="td-c td-grand-total">{{ t.hammasi || '' }}</td>
              </tr>
              <!-- Section 2 Subtotal -->
              <tr class="section-subtotal-row">
                <td colspan="3" class="text-center font-bold">Jami</td>
                <td class="td-c font-bold">{{ summaryData.sections.ichki.totalStaff }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.ichki.totals.maruza || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.ichki.totals.amaliy || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.ichki.totals.seminar || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.ichki.totals.laboratoriya || '' }}</td>
                <td class="td-c font-bold td-audit-total">{{ summaryData.sections.ichki.totals.jamiAuditoriya || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.ichki.totals.kursIshi || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.ichki.totals.kursIshiHimoya || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.ichki.totals.kursLoyihasi || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.ichki.totals.kursLoyihasiHimoya || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.ichki.totals.hisobChizma || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.ichki.totals.oraliq || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.ichki.totals.yakuniy || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.ichki.totals.amaliyotInd || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.ichki.totals.amaliyotUni || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.ichki.totals.amaliyotTash || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.ichki.totals.bmiRahbar || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.ichki.totals.bmiDak || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.ichki.totals.magistr || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.ichki.totals.mdIti || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.ichki.totals.mdDak || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.ichki.totals.doktorant || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.ichki.totals.yadaYozmaGuruh || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.ichki.totals.yadaYozmaTalaba || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.ichki.totals.yadaTest || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.ichki.totals.ochiqLeksiya || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.ichki.totals.malakaOshirish || '' }}</td>
                <td class="td-c font-bold td-tashqari-total">{{ summaryData.sections.ichki.totals.jamiTashqari || '' }}</td>
                <td class="td-c font-bold td-grand-total">{{ summaryData.sections.ichki.totals.hammasi || '' }}</td>
              </tr>

              <!-- SECTION 3: Soatbay asosida (agar mavjud bo'lsa) -->
              <template v-if="summaryData.sections.soatbay.teachers.length > 0">
                <tr class="section-title-row">
                  <td colspan="32">Soatbay asosida</td>
                </tr>
                <tr v-for="(t, idx) in summaryData.sections.soatbay.teachers" :key="'soatbay_' + idx">
                  <td class="td-c">{{ idx + 1 }}</td>
                  <td class="td-name">{{ t.name }}</td>
                  <td class="td-c text-red-600 font-semibold">{{ t.position }}</td>
                  <td class="td-c">{{ t.staff }}</td>
                  <td class="td-c">{{ t.maruza || '' }}</td>
                  <td class="td-c">{{ t.amaliy || '' }}</td>
                  <td class="td-c">{{ t.seminar || '' }}</td>
                  <td class="td-c">{{ t.laboratoriya || '' }}</td>
                  <td class="td-c td-audit-total">{{ t.jamiAuditoriya || '' }}</td>
                  <td class="td-c">{{ t.kursIshi || '' }}</td>
                  <td class="td-c">{{ t.kursIshiHimoya || '' }}</td>
                  <td class="td-c">{{ t.kursLoyihasi || '' }}</td>
                  <td class="td-c">{{ t.kursLoyihasiHimoya || '' }}</td>
                  <td class="td-c">{{ t.hisobChizma || '' }}</td>
                  <td class="td-c">{{ t.oraliq || '' }}</td>
                  <td class="td-c">{{ t.yakuniy || '' }}</td>
                  <td class="td-c">{{ t.amaliyotInd || '' }}</td>
                  <td class="td-c">{{ t.amaliyotUni || '' }}</td>
                  <td class="td-c">{{ t.amaliyotTash || '' }}</td>
                  <td class="td-c">{{ t.bmiRahbar || '' }}</td>
                  <td class="td-c">{{ t.bmiDak || '' }}</td>
                  <td class="td-c">{{ t.magistr || '' }}</td>
                  <td class="td-c">{{ t.mdIti || '' }}</td>
                  <td class="td-c">{{ t.mdDak || '' }}</td>
                  <td class="td-c">{{ t.doktorant || '' }}</td>
                  <td class="td-c">{{ t.yadaYozmaGuruh || '' }}</td>
                  <td class="td-c">{{ t.yadaYozmaTalaba || '' }}</td>
                  <td class="td-c">{{ t.yadaTest || '' }}</td>
                  <td class="td-c">{{ t.ochiqLeksiya || '' }}</td>
                  <td class="td-c">{{ t.malakaOshirish || '' }}</td>
                  <td class="td-c td-tashqari-total">{{ t.jamiTashqari || '' }}</td>
                  <td class="td-c td-grand-total">{{ t.hammasi || '' }}</td>
                </tr>
                <tr class="section-subtotal-row">
                  <td colspan="3" class="text-center font-bold">Jami</td>
                  <td class="td-c font-bold">{{ summaryData.sections.soatbay.totalStaff }}</td>
                  <td class="td-c font-bold">{{ summaryData.sections.soatbay.totals.maruza || '' }}</td>
                  <td class="td-c font-bold">{{ summaryData.sections.soatbay.totals.amaliy || '' }}</td>
                  <td class="td-c font-bold">{{ summaryData.sections.soatbay.totals.seminar || '' }}</td>
                  <td class="td-c font-bold">{{ summaryData.sections.soatbay.totals.laboratoriya || '' }}</td>
                  <td class="td-c font-bold td-audit-total">{{ summaryData.sections.soatbay.totals.jamiAuditoriya || '' }}</td>
                  <td class="td-c font-bold">{{ summaryData.sections.soatbay.totals.kursIshi || '' }}</td>
                  <td class="td-c font-bold">{{ summaryData.sections.soatbay.totals.kursIshiHimoya || '' }}</td>
                  <td class="td-c font-bold">{{ summaryData.sections.soatbay.totals.kursLoyihasi || '' }}</td>
                  <td class="td-c font-bold">{{ summaryData.sections.soatbay.totals.kursLoyihasiHimoya || '' }}</td>
                  <td class="td-c font-bold">{{ summaryData.sections.soatbay.totals.hisobChizma || '' }}</td>
                  <td class="td-c font-bold">{{ summaryData.sections.soatbay.totals.oraliq || '' }}</td>
                  <td class="td-c font-bold">{{ summaryData.sections.soatbay.totals.yakuniy || '' }}</td>
                  <td class="td-c font-bold">{{ summaryData.sections.soatbay.totals.amaliyotInd || '' }}</td>
                  <td class="td-c font-bold">{{ summaryData.sections.soatbay.totals.amaliyotUni || '' }}</td>
                  <td class="td-c font-bold">{{ summaryData.sections.soatbay.totals.amaliyotTash || '' }}</td>
                  <td class="td-c font-bold">{{ summaryData.sections.soatbay.totals.bmiRahbar || '' }}</td>
                  <td class="td-c font-bold">{{ summaryData.sections.soatbay.totals.bmiDak || '' }}</td>
                  <td class="td-c font-bold">{{ summaryData.sections.soatbay.totals.magistr || '' }}</td>
                  <td class="td-c font-bold">{{ summaryData.sections.soatbay.totals.mdIti || '' }}</td>
                  <td class="td-c font-bold">{{ summaryData.sections.soatbay.totals.mdDak || '' }}</td>
                  <td class="td-c font-bold">{{ summaryData.sections.soatbay.totals.doktorant || '' }}</td>
                  <td class="td-c font-bold">{{ summaryData.sections.soatbay.totals.yadaYozmaGuruh || '' }}</td>
                  <td class="td-c font-bold">{{ summaryData.sections.soatbay.totals.yadaYozmaTalaba || '' }}</td>
                  <td class="td-c font-bold">{{ summaryData.sections.soatbay.totals.yadaTest || '' }}</td>
                  <td class="td-c font-bold">{{ summaryData.sections.soatbay.totals.ochiqLeksiya || '' }}</td>
                  <td class="td-c font-bold">{{ summaryData.sections.soatbay.totals.malakaOshirish || '' }}</td>
                  <td class="td-c font-bold td-tashqari-total">{{ summaryData.sections.soatbay.totals.jamiTashqari || '' }}</td>
                  <td class="td-c font-bold td-grand-total">{{ summaryData.sections.soatbay.totals.hammasi || '' }}</td>
                </tr>
              </template>

              <!-- SECTION 4: Vakant soatlar -->
              <tr class="section-title-row">
                <td colspan="32">Vakant soatlar</td>
              </tr>
              <tr v-for="(t, idx) in summaryData.sections.vakant.teachers" :key="'vakant_' + idx">
                <td class="td-c">{{ idx + 1 }}</td>
                <td class="td-name">{{ t.name }}</td>
                <td class="td-c">{{ t.position }}</td>
                <td class="td-c">{{ t.staff || '' }}</td>
                <td class="td-c">{{ t.maruza || '' }}</td>
                <td class="td-c">{{ t.amaliy || '' }}</td>
                <td class="td-c">{{ t.seminar || '' }}</td>
                <td class="td-c">{{ t.laboratoriya || '' }}</td>
                <td class="td-c td-audit-total">{{ t.jamiAuditoriya || '' }}</td>
                <td class="td-c">{{ t.kursIshi || '' }}</td>
                <td class="td-c">{{ t.kursIshiHimoya || '' }}</td>
                <td class="td-c">{{ t.kursLoyihasi || '' }}</td>
                <td class="td-c">{{ t.kursLoyihasiHimoya || '' }}</td>
                <td class="td-c">{{ t.hisobChizma || '' }}</td>
                <td class="td-c">{{ t.oraliq || '' }}</td>
                <td class="td-c">{{ t.yakuniy || '' }}</td>
                <td class="td-c">{{ t.amaliyotInd || '' }}</td>
                <td class="td-c">{{ t.amaliyotUni || '' }}</td>
                <td class="td-c">{{ t.amaliyotTash || '' }}</td>
                <td class="td-c">{{ t.bmiRahbar || '' }}</td>
                <td class="td-c">{{ t.bmiDak || '' }}</td>
                <td class="td-c">{{ t.magistr || '' }}</td>
                <td class="td-c">{{ t.mdIti || '' }}</td>
                <td class="td-c">{{ t.mdDak || '' }}</td>
                <td class="td-c">{{ t.doktorant || '' }}</td>
                <td class="td-c">{{ t.yadaYozmaGuruh || '' }}</td>
                <td class="td-c">{{ t.yadaYozmaTalaba || '' }}</td>
                <td class="td-c">{{ t.yadaTest || '' }}</td>
                <td class="td-c">{{ t.ochiqLeksiya || '' }}</td>
                <td class="td-c">{{ t.malakaOshirish || '' }}</td>
                <td class="td-c td-tashqari-total">{{ t.jamiTashqari || '' }}</td>
                <td class="td-c td-grand-total">{{ t.hammasi || '' }}</td>
              </tr>
              <!-- Section 4 Subtotal -->
              <tr class="section-subtotal-row">
                <td colspan="3" class="text-center font-bold">Jami</td>
                <td class="td-c font-bold">{{ summaryData.sections.vakant.totalStaff || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.vakant.totals.maruza || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.vakant.totals.amaliy || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.vakant.totals.seminar || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.vakant.totals.laboratoriya || '' }}</td>
                <td class="td-c font-bold td-audit-total">{{ summaryData.sections.vakant.totals.jamiAuditoriya || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.vakant.totals.kursIshi || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.vakant.totals.kursIshiHimoya || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.vakant.totals.kursLoyihasi || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.vakant.totals.kursLoyihasiHimoya || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.vakant.totals.hisobChizma || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.vakant.totals.oraliq || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.vakant.totals.yakuniy || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.vakant.totals.amaliyotInd || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.vakant.totals.amaliyotUni || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.vakant.totals.amaliyotTash || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.vakant.totals.bmiRahbar || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.vakant.totals.bmiDak || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.vakant.totals.magistr || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.vakant.totals.mdIti || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.vakant.totals.mdDak || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.vakant.totals.doktorant || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.vakant.totals.yadaYozmaGuruh || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.vakant.totals.yadaYozmaTalaba || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.vakant.totals.yadaTest || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.vakant.totals.ochiqLeksiya || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.vakant.totals.malakaOshirish || '' }}</td>
                <td class="td-c font-bold td-tashqari-total">{{ summaryData.sections.vakant.totals.jamiTashqari || '' }}</td>
                <td class="td-c font-bold td-grand-total">{{ summaryData.sections.vakant.totals.hammasi || '' }}</td>
              </tr>

              <!-- SECTION 5: Hammasi (Grand totals across all categories) -->
              <tr class="grand-total-row">
                <td colspan="3" class="text-center font-bold">Hammasi</td>
                <td class="td-c font-bold">{{ summaryData.hammasi.totalStaff }}</td>
                <td class="td-c font-bold">{{ summaryData.hammasi.totals.maruza || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.hammasi.totals.amaliy || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.hammasi.totals.seminar || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.hammasi.totals.laboratoriya || '' }}</td>
                <td class="td-c font-bold td-audit-total">{{ summaryData.hammasi.totals.jamiAuditoriya || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.hammasi.totals.kursIshi || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.hammasi.totals.kursIshiHimoya || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.hammasi.totals.kursLoyihasi || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.hammasi.totals.kursLoyihasiHimoya || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.hammasi.totals.hisobChizma || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.hammasi.totals.oraliq || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.hammasi.totals.yakuniy || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.hammasi.totals.amaliyotInd || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.hammasi.totals.amaliyotUni || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.hammasi.totals.amaliyotTash || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.hammasi.totals.bmiRahbar || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.hammasi.totals.bmiDak || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.hammasi.totals.magistr || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.hammasi.totals.mdIti || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.hammasi.totals.mdDak || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.hammasi.totals.doktorant || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.hammasi.totals.yadaYozmaGuruh || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.sections.asosiy.totals.yadaYozmaTalaba ? summaryData.hammasi.totals.yadaYozmaTalaba : (summaryData.hammasi.totals.yadaYozmaTalaba || '') }}</td>
                <td class="td-c font-bold">{{ summaryData.hammasi.totals.yadaTest || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.hammasi.totals.ochiqLeksiya || '' }}</td>
                <td class="td-c font-bold">{{ summaryData.hammasi.totals.malakaOshirish || '' }}</td>
                <td class="td-c font-bold td-tashqari-total">{{ summaryData.hammasi.totals.jamiTashqari || '' }}</td>
                <td class="td-c font-bold td-grand-total">{{ summaryData.hammasi.totals.hammasi || '' }}</td>
              </tr>

              <!-- SECTION 6: Umumiy soat -->
              <tr class="final-total-row">
                <td colspan="3" class="text-right font-bold pr-4">Umumiy soat</td>
                <td class="td-c font-bold">{{ summaryData.hammasi.totalStaff }}</td>
                <td colspan="27"></td>
                <td class="td-c font-bold final-total-cell">{{ summaryData.umumiySoat }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Footer Signers Box -->
        <div class="doc-footer-box">
          <div class="footer-signer">
            <b>Kafedra mudiri, dotsent:</b>
            <span class="signer-name">{{ summaryData.department.mudirName || "_________________________" }}</span>
          </div>
          <div class="footer-signer">
            <b>Fakultet dekani, dotsent:</b>
            <span class="signer-name">{{ summaryData.department.dekanName || "_________________________" }}</span>
          </div>
        </div>

      </div>

      <!-- Empty State -->
      <div v-else class="empty-state">
        <p>Iltimos, kafedrani tanlang.</p>
      </div>

    </div>
  </div>
</template>

<script>
import axios from "axios";
import SearchableSelect from "@/components/SearchableSelect.vue";
import * as XLSX from "xlsx";

const API = process.env.VUE_APP_API_URL;

export default {
  name: "YuklamaVaTaqsimot",
  components: {
    SearchableSelect
  },
  data() {
    return {
      loading: false,
      departments: [],
      selectedDepartmentId: null,
      selectedYear: "2026-2027",
      summaryData: null,
      userRole: "",
      userDepartmentId: null
    };
  },
  computed: {
    isKafedraMudirRole() {
      const roleLower = (this.userRole || "").toLowerCase().trim();
      return ["kafedra mudiri", "kafedra_mudiri", "mudir"].some(r => roleLower.includes(r)) && !!this.userDepartmentId;
    },
    filteredDepartments() {
      if (this.isKafedraMudirRole) {
        return this.departments.filter(d => String(d.departmentId || d.id) === String(this.userDepartmentId));
      }
      return this.departments;
    },
    kafedraOptions() {
      return this.filteredDepartments.map(d => ({
        value: d.departmentId || d.id,
        label: d.name
      }));
    }
  },
  async created() {
    const data = localStorage.getItem("user");
    if (data && data !== "undefined") {
      try {
        const parsed = JSON.parse(data);
        if (
          (parsed.phone === 'j_raxmankulov' || (parsed.name && parsed.name.toLowerCase().includes('raxmankulov'))) &&
          Number(parsed.departmentId) !== 12
        ) {
          parsed.departmentId = 12;
          localStorage.setItem("user", JSON.stringify(parsed));
        }
        this.userRole = parsed.role || "";
        this.userDepartmentId = parsed.departmentId || null;
      } catch (e) { /* ignore */ }
    }

    await this.fetchDepartments();

    // Kafedra mudiri uchun faqat o'z kafedrasi
    if (this.isKafedraMudirRole && this.userDepartmentId) {
      this.selectedDepartmentId = Number(this.userDepartmentId);
    } else if (this.$route.query.departmentId) {
      this.selectedDepartmentId = Number(this.$route.query.departmentId);
    } else if (this.departments.length > 0) {
      this.selectedDepartmentId = this.departments[0].departmentId || this.departments[0].id;
    }

    if (this.selectedDepartmentId) {
      await this.fetchSummaryData();
    }
  },
  methods: {
    async fetchDepartments() {
      try {
        const res = await axios.get(`${API}/kafedra`);
        const list = res.data?.data || [];
        // Saralash nomi bo'yicha
        list.sort((a, b) => (a.name || "").localeCompare(b.name || ""));
        this.departments = list;
      } catch (err) {
        console.error("Kafedralarni olishda xato:", err);
      }
    },
    onDepartmentChange() {
      if (this.isKafedraMudirRole && this.userDepartmentId) {
        this.selectedDepartmentId = Number(this.userDepartmentId);
      }
      this.fetchSummaryData();
    },
    async fetchSummaryData() {
      if (!this.selectedDepartmentId) return;
      this.loading = true;
      try {
        const res = await axios.get(`${API}/yuklama-va-taqsimot/summary`, {
          params: {
            departmentId: this.selectedDepartmentId,
            oquvYili: this.selectedYear
          }
        });
        if (res.data?.success) {
          this.summaryData = res.data.data;
        } else {
          this.summaryData = null;
        }
      } catch (err) {
        console.error("Summary yuklashda xato:", err);
        this.summaryData = null;
      } finally {
        this.loading = false;
      }
    },
    printTable() {
      window.print();
    },
    exportToExcel() {
      if (!this.summaryData) return;

      const depName = this.summaryData.department?.name || "";
      const mudirName = this.summaryData.department?.mudirName || "_________________________";
      const dekanName = this.summaryData.department?.dekanName || "_________________________";

      const rows = [];
      const merges = [];

      // 1. TOP SIGNERS (Tasdiqlayman & Kelishildi)
      // Row 0
      const r0 = new Array(31).fill("");
      r0[0] = '"Tasdiqlayman"';
      r0[24] = '"Kelishildi"';
      rows.push(r0);
      merges.push({ s: { r: 0, c: 0 }, e: { r: 0, c: 6 } });
      merges.push({ s: { r: 0, c: 24 }, e: { r: 0, c: 30 } });

      // Row 1
      const r1 = new Array(31).fill("");
      r1[0] = "O'quv ishlari bo'yicha prorektor";
      r1[24] = "O'quv-uslubiy boshqarma boshlig'i";
      rows.push(r1);
      merges.push({ s: { r: 1, c: 0 }, e: { r: 1, c: 6 } });
      merges.push({ s: { r: 1, c: 24 }, e: { r: 1, c: 30 } });

      // Row 2
      const r2 = new Array(31).fill("");
      r2[0] = "___________ B.Primkulov";
      r2[24] = "___________ A.Ibragimov";
      rows.push(r2);
      merges.push({ s: { r: 2, c: 0 }, e: { r: 2, c: 6 } });
      merges.push({ s: { r: 2, c: 24 }, e: { r: 2, c: 30 } });

      // Row 3
      const r3 = new Array(31).fill("");
      r3[0] = "«____» ____________ 2026 y.";
      r3[24] = "«____» ____________ 2026 y.";
      rows.push(r3);
      merges.push({ s: { r: 3, c: 0 }, e: { r: 3, c: 6 } });
      merges.push({ s: { r: 3, c: 24 }, e: { r: 3, c: 30 } });

      // Row 4 (bo'sh qator)
      rows.push(new Array(31).fill(""));

      // 2. MAIN TITLE
      // Row 5
      const r5 = new Array(31).fill("");
      r5[0] = `Termiz davlat muhandislik va agrotexnologiyalar universiteti ${depName} kafedrasi professor-o'qituvchilariga ${this.selectedYear} o'quv yili uchun o'quv yuklama`;
      rows.push(r5);
      merges.push({ s: { r: 5, c: 0 }, e: { r: 5, c: 30 } });

      // Row 6 (SUB-TITLE)
      const r6 = new Array(31).fill("");
      r6[0] = "TAQSIMOTI";
      rows.push(r6);
      merges.push({ s: { r: 6, c: 0 }, e: { r: 6, c: 30 } });

      // Row 7 (bo'sh qator)
      rows.push(new Array(31).fill(""));

      // 3. TABLE HEADERS
      // Row 8 (Header 1)
      const h1 = new Array(31).fill("");
      h1[0] = "№";
      h1[1] = "Professor-o'qituvchining familiyasi, ismi, sharifi";
      h1[2] = "Lavozimi";
      h1[3] = "Shtat birligi";
      h1[4] = "Auditoriya mashg'ulotlari";
      h1[9] = "Auditoriyadan tashqari mashg'ulotlari";
      h1[29] = "Jami auditoriyadan tashqari soat";
      h1[30] = "Hammasi";
      rows.push(h1);

      // Row 9 (Header 2)
      const h2 = [
        "", "", "", "",
        "Ma'ruza",
        "Amaliy mashg'ulot",
        "Laboratoriya",
        "Seminar",
        "Jami auditoriya soati",
        "Kurs ishi (Talaba soni*2)",
        "Kurs ishi himoyasi (Talaba soni*0,4)",
        "Kurs loyihasi (Talaba soni*3)",
        "Kurs loyihasi himoyasi (Talaba soni*0,6)",
        "Hisob chizma ishi (Talaba soni*0,3)",
        "Oraliq nazorat (Talaba soni*0,2)",
        "Yakuniy nazorat (Talaba soni*0,3)",
        "Malakaviy amaliyot individual (talaba soni*2)",
        "Malakaviy amaliyot universitet hududida (3*6*hafta soni*guruh soni)",
        "Malakaviy amaliyot universitetdan tashqari hududda (boshqa ta'lim yo'nalishi talaba soni*25, sirtqi yo'nalishiga talaba soni*50)",
        "BMI rahbarlik (Boshqa ta'lim yo'nalishlari talaba soni*25, texnik yo'nalishlarga talaba soni*30)",
        "BMI/DAK (Talaba soni*0,4)",
        "Magistrlik IPF va amaliyotga rahbarlik (Talaba soni*50)",
        "MD - ITI ga rahbarlik qilish (Talaba soni*50)",
        "Doktorantga (stajyor tadqiqotchiga talaba soni*75) rahbarlik (Talaba soni*100)",
        "YaDA yozma ish guruh soni*3",
        "YaDA yozma ish tekshirish uchun talaba soni*0,2",
        "YaDA test guruh soni*1",
        "Ochiq leksiya (dars soni*5)",
        "Respublika ta'lim muassasalarida markazlarida malaka oshirishlarni o'tash",
        "",
        ""
      ];
      rows.push(h2);

      // Merges for Headers (Row 8 & 9)
      merges.push({ s: { r: 8, c: 0 }, e: { r: 9, c: 0 } });   // №
      merges.push({ s: { r: 8, c: 1 }, e: { r: 9, c: 1 } });   // F.I.O
      merges.push({ s: { r: 8, c: 2 }, e: { r: 9, c: 2 } });   // Lavozimi
      merges.push({ s: { r: 8, c: 3 }, e: { r: 9, c: 3 } });   // Shtat
      merges.push({ s: { r: 8, c: 4 }, e: { r: 8, c: 8 } });   // Auditoriya mashg'ulotlari (4..8)
      merges.push({ s: { r: 8, c: 9 }, e: { r: 8, c: 28 } });  // Tashqari mashg'ulotlari (9..28)
      merges.push({ s: { r: 8, c: 29 }, e: { r: 9, c: 29 } }); // Jami tashqari
      merges.push({ s: { r: 8, c: 30 }, e: { r: 9, c: 30 } }); // Hammasi

      // Helper function to add a section
      const addSection = (sectionTitle, sectionObj) => {
        // Section title row
        const titleRow = new Array(31).fill("");
        titleRow[0] = sectionTitle;
        const titleRowIdx = rows.length;
        rows.push(titleRow);
        merges.push({ s: { r: titleRowIdx, c: 0 }, e: { r: titleRowIdx, c: 30 } });

        // Teachers rows
        sectionObj.teachers.forEach((t, i) => {
          rows.push([
            i + 1,
            t.name || "",
            t.position || "",
            t.staff ?? "",
            t.maruza || "",
            t.amaliy || "",
            t.laboratoriya || "",
            t.seminar || "",
            t.jamiAuditoriya || "",
            t.kursIshi || "",
            t.kursIshiHimoya || "",
            t.kursLoyihasi || "",
            t.kursLoyihasiHimoya || "",
            t.hisobChizma || "",
            t.oraliq || "",
            t.yakuniy || "",
            t.amaliyotInd || "",
            t.amaliyotUni || "",
            t.amaliyotTash || "",
            t.bmiRahbar || "",
            t.bmiDak || "",
            t.magistr || "",
            t.mdIti || "",
            t.doktorant || "",
            t.yadaYozmaGuruh || "",
            t.yadaYozmaTalaba || "",
            t.yadaTest || "",
            t.ochiqLeksiya || "",
            t.malakaOshirish || "",
            t.jamiTashqari || "",
            t.hammasi || ""
          ]);
        });

        // Jami subtotal row
        const jamiRowIdx = rows.length;
        rows.push([
          "Jami", "", "",
          sectionObj.totalStaff ?? "",
          sectionObj.totals?.maruza || "",
          sectionObj.totals?.amaliy || "",
          sectionObj.totals?.laboratoriya || "",
          sectionObj.totals?.seminar || "",
          sectionObj.totals?.jamiAuditoriya || "",
          sectionObj.totals?.kursIshi || "",
          sectionObj.totals?.kursIshiHimoya || "",
          sectionObj.totals?.kursLoyihasi || "",
          sectionObj.totals?.kursLoyihasiHimoya || "",
          sectionObj.totals?.hisobChizma || "",
          sectionObj.totals?.oraliq || "",
          sectionObj.totals?.yakuniy || "",
          sectionObj.totals?.amaliyotInd || "",
          sectionObj.totals?.amaliyotUni || "",
          sectionObj.totals?.amaliyotTash || "",
          sectionObj.totals?.bmiRahbar || "",
          sectionObj.totals?.bmiDak || "",
          sectionObj.totals?.magistr || "",
          sectionObj.totals?.mdIti || "",
          sectionObj.totals?.doktorant || "",
          sectionObj.totals?.yadaYozmaGuruh || "",
          sectionObj.totals?.yadaYozmaTalaba || "",
          sectionObj.totals?.yadaTest || "",
          sectionObj.totals?.ochiqLeksiya || "",
          sectionObj.totals?.malakaOshirish || "",
          sectionObj.totals?.jamiTashqari || "",
          sectionObj.totals?.hammasi || ""
        ]);
        merges.push({ s: { r: jamiRowIdx, c: 0 }, e: { r: jamiRowIdx, c: 2 } });
      };

      // 4. ADD SECTIONS
      addSection("Asosiy shtat bo'yicha", this.summaryData.sections.asosiy);
      addSection("Ichki o'rindoshlik asosida", this.summaryData.sections.ichki);
      if (this.summaryData.sections.soatbay?.teachers?.length > 0) {
        addSection("Soatbay asosida", this.summaryData.sections.soatbay);
      }
      addSection("Vakant soatlar", this.summaryData.sections.vakant);

      // 5. GRAND TOTAL (Hammasi)
      const hammasiRowIdx = rows.length;
      rows.push([
        "Hammasi", "", "",
        this.summaryData.hammasi?.totalStaff ?? "",
        this.summaryData.hammasi?.totals?.maruza || "",
        this.summaryData.hammasi?.totals?.amaliy || "",
        this.summaryData.hammasi?.totals?.laboratoriya || "",
        this.summaryData.hammasi?.totals?.seminar || "",
        this.summaryData.hammasi?.totals?.jamiAuditoriya || "",
        this.summaryData.hammasi?.totals?.kursIshi || "",
        this.summaryData.hammasi?.totals?.kursIshiHimoya || "",
        this.summaryData.hammasi?.totals?.kursLoyihasi || "",
        this.summaryData.hammasi?.totals?.kursLoyihasiHimoya || "",
        this.summaryData.hammasi?.totals?.hisobChizma || "",
        this.summaryData.hammasi?.totals?.oraliq || "",
        this.summaryData.hammasi?.totals?.yakuniy || "",
        this.summaryData.hammasi?.totals?.amaliyotInd || "",
        this.summaryData.hammasi?.totals?.amaliyotUni || "",
        this.summaryData.hammasi?.totals?.amaliyotTash || "",
        this.summaryData.hammasi?.totals?.bmiRahbar || "",
        this.summaryData.hammasi?.totals?.bmiDak || "",
        this.summaryData.hammasi?.totals?.magistr || "",
        this.summaryData.hammasi?.totals?.mdIti || "",
        this.summaryData.hammasi?.totals?.doktorant || "",
        this.summaryData.hammasi?.totals?.yadaYozmaGuruh || "",
        this.summaryData.hammasi?.totals?.yadaYozmaTalaba || "",
        this.summaryData.hammasi?.totals?.yadaTest || "",
        this.summaryData.hammasi?.totals?.ochiqLeksiya || "",
        this.summaryData.hammasi?.totals?.malakaOshirish || "",
        this.summaryData.hammasi?.totals?.jamiTashqari || "",
        this.summaryData.hammasi?.totals?.hammasi || ""
      ]);
      merges.push({ s: { r: hammasiRowIdx, c: 0 }, e: { r: hammasiRowIdx, c: 2 } });

      // 6. UMUMIY SOAT
      const umumiyRowIdx = rows.length;
      const umumiyRow = new Array(31).fill("");
      umumiyRow[0] = "Umumiy soat";
      umumiyRow[3] = this.summaryData.hammasi?.totalStaff ?? "";
      umumiyRow[30] = this.summaryData.umumiySoat ?? "";
      rows.push(umumiyRow);
      merges.push({ s: { r: umumiyRowIdx, c: 0 }, e: { r: umumiyRowIdx, c: 2 } });
      merges.push({ s: { r: umumiyRowIdx, c: 4 }, e: { r: umumiyRowIdx, c: 29 } });

      // 7. BOTTOM SIGNERS (Mudir & Dekan)
      rows.push(new Array(31).fill("")); // bo'sh qator
      const signRow1Idx = rows.length;
      const signRow1 = new Array(31).fill("");
      signRow1[0] = "Kafedra mudiri, dotsent:";
      signRow1[3] = mudirName;
      signRow1[18] = "Fakultet dekani, dotsent:";
      signRow1[22] = dekanName;
      rows.push(signRow1);
      merges.push({ s: { r: signRow1Idx, c: 0 }, e: { r: signRow1Idx, c: 2 } });
      merges.push({ s: { r: signRow1Idx, c: 3 }, e: { r: signRow1Idx, c: 12 } });
      merges.push({ s: { r: signRow1Idx, c: 18 }, e: { r: signRow1Idx, c: 21 } });
      merges.push({ s: { r: signRow1Idx, c: 22 }, e: { r: signRow1Idx, c: 30 } });

      // Convert to sheet
      const ws = XLSX.utils.aoa_to_sheet(rows);
      ws['!merges'] = merges;

      // Column widths
      ws['!cols'] = [
        { wch: 5 },   // 0: №
        { wch: 38 },  // 1: F.I.O
        { wch: 16 },  // 2: Lavozimi
        { wch: 10 },  // 3: Shtat birligi
        { wch: 10 },  // 4: Ma'ruza
        { wch: 11 },  // 5: Amaliy
        { wch: 11 },  // 6: Laboratoriya
        { wch: 10 },  // 7: Seminar
        { wch: 13 },  // 8: Jami auditoriya
        { wch: 12 },  // 9: Kurs ishi
        { wch: 12 },  // 10: Kurs ishi himoyasi
        { wch: 12 },  // 11: Kurs loyihasi
        { wch: 12 },  // 12: Kurs loyihasi himoyasi
        { wch: 12 },  // 13: Hisob chizma
        { wch: 11 },  // 14: Oraliq nazorat
        { wch: 11 },  // 15: Yakuniy nazorat
        { wch: 13 },  // 16: Malakaviy amaliyot individual
        { wch: 14 },  // 17: Malakaviy amaliyot uni
        { wch: 15 },  // 18: Malakaviy amaliyot tashqari
        { wch: 13 },  // 19: BMI rahbarlik
        { wch: 12 },  // 20: BMI/DAK
        { wch: 13 },  // 21: Magistrlik IPF
        { wch: 13 },  // 22: MD ITI
        { wch: 13 },  // 23: Doktorant
        { wch: 12 },  // 24: YaDA yozma guruh
        { wch: 12 },  // 25: YaDA yozma talaba
        { wch: 12 },  // 26: YaDA test
        { wch: 12 },  // 27: Ochiq leksiya
        { wch: 14 },  // 28: Malaka oshirish
        { wch: 15 },  // 29: Jami auditoriyadan tashqari
        { wch: 13 }   // 30: Hammasi
      ];

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Taqsimot");

      const safeDepName = depName.replace(/[^a-zA-Z0-9а-яА-ЯёЁ]/g, '_');
      const fileName = `Taqsimot_${safeDepName}_${this.selectedYear}.xlsx`;
      XLSX.writeFile(wb, fileName);
    }
  }
};
</script>

<style scoped>
.page-wrapper {
  min-height: 100vh;
  background-color: #f8fafc;
  padding: 24px;
}

.page-container {
  max-width: 100%;
  margin: 0 auto;
}

/* Action Bar */
.action-bar-card {
  background: #ffffff;
  padding: 18px 24px;
  border-radius: 16px;
  box-shadow: 0 4px 20px -2px rgba(0, 0, 0, 0.05), 0 2px 6px -1px rgba(0, 0, 0, 0.02);
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 24px;
  border: 1px solid #e2e8f0;
}

.filters-left {
  display: flex;
  align-items: flex-end;
  gap: 20px;
  flex-wrap: wrap;
  flex: 1;
}

.select-box {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.select-kafedra {
  width: 400px;
  min-width: 280px;
}

.select-year {
  width: 170px;
}

.field-label {
  font-size: 13px;
  font-weight: 600;
  color: #334155;
  display: flex;
  align-items: center;
  gap: 6px;
}

.label-icon {
  color: #64748b;
}

.year-select-wrapper {
  position: relative;
}

.form-select {
  width: 100%;
  height: 42px;
  padding: 0 14px;
  border-radius: 10px;
  border: 1.5px solid #cbd5e1;
  background-color: #f8fafc;
  color: #0f172a;
  font-size: 14px;
  font-weight: 600;
  outline: none;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.form-select:hover {
  border-color: #94a3b8;
  background-color: #ffffff;
}

.form-select:focus {
  border-color: #3b82f6;
  background-color: #ffffff;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
}

.actions-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.btn-action {
  height: 42px;
  padding: 0 20px;
  border-radius: 10px;
  font-size: 13.5px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.25s ease;
  border: none;
  box-sizing: border-box;
  white-space: nowrap;
}

.btn-excel {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: #ffffff;
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);
}

.btn-excel:hover:not(:disabled) {
  background: linear-gradient(135deg, #059669 0%, #047857 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 14px rgba(16, 185, 129, 0.4);
}

.btn-print {
  background: linear-gradient(135deg, #334155 0%, #1e293b 100%);
  color: #ffffff;
  box-shadow: 0 2px 8px rgba(30, 41, 59, 0.25);
}

.btn-print:hover:not(:disabled) {
  background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 14px rgba(30, 41, 59, 0.35);
}

.btn-refresh {
  background: #ffffff;
  color: #334155;
  border: 1.5px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.btn-refresh:hover:not(:disabled) {
  background: #f8fafc;
  color: #0f172a;
  border-color: #cbd5e1;
  transform: translateY(-2px);
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.08);
}

.btn-action:active:not(:disabled) {
  transform: translateY(0);
}

.btn-action:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  transform: none !important;
  box-shadow: none !important;
}

.spinning {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* Document Container */
.document-container {
  background: #ffffff;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
  border: 1px solid #e2e8f0;
}

/* Signers Header */
.doc-header-box {
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
  font-family: 'Times New Roman', Times, serif;
}

.signer-col {
  width: 320px;
  text-align: center;
  font-size: 14px;
  line-height: 1.5;
}

.signer-title {
  font-weight: bold;
  font-size: 15px;
}

.signer-line {
  margin-top: 15px;
  font-weight: bold;
}

.signer-date {
  margin-top: 6px;
  font-style: italic;
}

.doc-main-title {
  text-align: center;
  font-family: 'Times New Roman', Times, serif;
  font-size: 15px;
  font-weight: bold;
  margin-top: 10px;
  line-height: 1.4;
}

.doc-sub-title {
  text-align: center;
  font-family: 'Times New Roman', Times, serif;
  font-size: 16px;
  font-weight: 800;
  letter-spacing: 1px;
  margin-top: 4px;
  margin-bottom: 20px;
}

/* Table */
.table-responsive {
  overflow-x: auto;
  border: 1.5px solid #000000;
}

.taqsimot-table {
  width: 100%;
  border-collapse: collapse;
  font-family: 'Times New Roman', Times, serif;
  font-size: 12px;
  color: #000000;
}

.taqsimot-table th,
.taqsimot-table td {
  border: 1px solid #000000;
  padding: 3px 4px;
}

.taqsimot-table thead th {
  background-color: #ffffff;
  text-align: center;
  vertical-align: middle;
  font-weight: bold;
}

.th-num { width: 28px; }
.th-name { width: 230px; min-width: 200px; text-align: left; }
.th-pos { width: 85px; }
.th-staff { width: 55px; }

.th-group-audit {
  background-color: #f1f5f9;
  font-size: 13px;
  padding: 6px 0;
}

.th-group-tashqari {
  background-color: #f8fafc;
  font-size: 13px;
  padding: 6px 0;
}

.sub-header-row th {
  height: 180px;
  vertical-align: bottom;
  padding-bottom: 8px;
}

.v-text {
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  white-space: nowrap;
  font-size: 11px;
  font-weight: 600;
  margin: 0 auto;
  letter-spacing: -0.3px;
}

/* Highlights */
.th-audit-total,
.td-audit-total {
  background-color: #fff9db !important; /* Soft yellow */
  font-weight: bold;
}

.th-jami-tashqari,
.td-tashqari-total {
  background-color: #fff9db !important; /* Soft yellow */
  font-weight: bold;
}

.th-hammasi,
.td-grand-total {
  background-color: #fef08a !important; /* Yellow */
  font-weight: bold;
}

/* Row types */
.section-title-row td {
  background-color: #e2e8f0;
  font-weight: bold;
  text-align: center !important;
  font-size: 13.5px;
  padding: 6px 12px;
  letter-spacing: 0.5px;
  color: #000000;
  vertical-align: middle;
}

.section-subtotal-row td {
  background-color: #bae6fd; /* Light cyan/blue */
  font-weight: bold;
}

.grand-total-row td {
  background-color: #7dd3fc; /* Deeper blue */
  font-weight: 800;
}

.final-total-row td {
  background-color: #e0e7ff; /* Purple/indigo */
  font-weight: 800;
  font-size: 13px;
}

.final-total-cell {
  background-color: #c7d2fe !important;
  font-size: 14px;
}

.td-c {
  text-align: center;
}

.td-name {
  text-align: left;
  font-weight: 500;
  padding-left: 6px !important;
}

/* Footer Box */
.doc-footer-box {
  display: flex;
  justify-content: space-between;
  margin-top: 36px;
  padding: 0 20px;
  font-family: 'Times New Roman', Times, serif;
  font-size: 14px;
}

.footer-signer {
  display: flex;
  align-items: center;
  gap: 12px;
}

.signer-name {
  font-weight: bold;
  text-decoration: underline;
}

/* Loading / Empty */
.loading-state,
.empty-state {
  background: #ffffff;
  padding: 60px 20px;
  text-align: center;
  border-radius: 12px;
  color: #64748b;
  border: 1px solid #e2e8f0;
}

.spinner {
  width: 36px;
  height: 36px;
  border: 3px solid #e2e8f0;
  border-top-color: #2563eb;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin: 0 auto 16px;
}

/* Print CSS */
@media print {
  .no-print {
    display: none !important;
  }
  .page-wrapper {
    background: #ffffff !important;
    padding: 0 !important;
  }
  .document-container {
    box-shadow: none !important;
    border: none !important;
    padding: 0 !important;
  }
  .table-responsive {
    overflow: visible !important;
  }
}
</style>
